'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var request = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(ctx, next) {
        var params;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        params = ctx.req.params || {};
                        _context.next = 3;
                        return new Promise(function (resolve, reject) {
                            if (params.type === 'jsonp' && params.method !== 'post') {
                                var jsonpUrl = params.url;
                                if (params.data && (0, _typeof3.default)(params.data) === 'object') {
                                    jsonpUrl = (0, _utils.urlQueryJoin)(params.url, params.data);
                                }

                                // 发起jsonp请求
                                (0, _jsonp2.default)(jsonpUrl, {
                                    // 指定 jsonp 的回调查询参数，默认是 `callback`
                                    param: params.jsonpCallback,
                                    // 指定 jsonp 回掉函数名，
                                    name: params.jsonpCallbackName || '__zoro_request_' + window.__zoro_request_jsonp_count__++, // eslint-disable-line
                                    // 超时时间，默认5s
                                    timeout: params.timeout
                                }, function (err, data) {
                                    if (err) {
                                        ctx.res.error = err;
                                        reject(ctx);
                                    } else {
                                        ctx.res.data = data;
                                        resolve(ctx);
                                    }
                                });
                            } else if (params.type === 'jsonp' && params.method === 'post') {
                                // 请求post并且返回结果是jsonp形式的
                                (0, _postJsonp2.default)(params).then(function (response) {
                                    ctx.res.status = response.status;
                                    ctx.res.statusText = response.statusText;
                                    ctx.res.headers = response.headers;
                                    ctx.res.data = response.data;
                                    ctx.res.request = response.request;
                                    ctx.res.config = response.config;

                                    resolve(ctx);
                                }).catch(function (err) {
                                    ctx.res.error = err;
                                    reject(ctx);
                                });
                            } else if (params.type === 'script') {
                                if (params.data && (0, _typeof3.default)(params.data) === 'object') {
                                    params.url = (0, _utils.urlQueryJoin)(params.url, params.data);
                                }
                                (0, _loadScript2.default)(params).then(function () {
                                    resolve(ctx);
                                }).catch(function () {
                                    ctx.res.error = 'loadScript error';
                                    reject(ctx);
                                });
                            } else {
                                var axiosParams = (0, _utils.toAxiosParams)(params);

                                // 发起axios的普通请求
                                (0, _axios2.default)(axiosParams).then(function (response) {
                                    ctx.res.status = response.status;
                                    ctx.res.statusText = response.statusText;
                                    ctx.res.headers = response.headers;
                                    ctx.res.data = response.data;
                                    ctx.res.request = response.request;
                                    ctx.res.config = response.config;

                                    resolve(ctx);
                                }).catch(function (err) {
                                    ctx.res.error = err;
                                    reject(err);
                                });
                            }
                        });

                    case 3:
                        _context.next = 5;
                        return next();

                    case 5:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function request(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _jsonp = require('jsonp');

var _jsonp2 = _interopRequireDefault(_jsonp);

var _loadScript = require('./loadScript');

var _loadScript2 = _interopRequireDefault(_loadScript);

var _postJsonp = require('./postJsonp');

var _postJsonp2 = _interopRequireDefault(_postJsonp);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.__zoro_request_jsonp_count__ = window.__zoro_request_jsonp_count__ || 1;

exports.default = request;